function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { View, Text, Spinner } from "./native";
import { ScreenMediaQuery } from "./Grid";
import wrapComponent from "../core/wrapComponent";

function ScreenElement(props, ref) {
  const {
    children,
    isLoading = false,
    loadingText = 'Loading...',
    style = {},
    mobile,
    tablet,
    desktop
  } = props,
        rest = _objectWithoutProperties(props, ["children", "isLoading", "loadingText", "style", "mobile", "tablet", "desktop"]);

  const screenMediaQueries = _objectSpread(_objectSpread(_objectSpread({}, desktop ? {
    desktop: () => desktop({})
  } : {}), tablet ? {
    tablet: () => tablet({})
  } : {}), mobile ? {
    mobile: () => mobile({})
  } : {});

  return /*#__PURE__*/React.createElement(View // @ts-ignore
  , _extends({
    ref: ref,
    style: [{
      width: '100%',
      height: '100%'
    }, style]
  }, rest), isLoading ? /*#__PURE__*/React.createElement(View, {
    style: {
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(View, {
    style: {
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Spinner, null), /*#__PURE__*/React.createElement(Text, null, loadingText))) : /*#__PURE__*/React.createElement(ScreenMediaQuery, _extends({
    style: {
      width: '100%',
      height: '100%',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, screenMediaQueries), children));
}

export default wrapComponent(ScreenElement, {
  isForwardRef: true
});